import React, { useEffect, useState } from 'react';

/** 全局断网状态条：真实连接状态反馈，非业务说明书 */
export default function NetworkStatusBanner() {
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-[60] w-full bg-amber-600 px-3 py-1.5 text-center text-sm text-white"
    >
      网络已断开，请检查连接后重试
    </div>
  );
}
